import * as service from "../common/service";
import { getCurrentApiBaseUrl } from "../common/constants";

// Dynamic API URL functions that get the current API base URL at runtime
const getLoginApi = () => `${getCurrentApiBaseUrl()}/auth/login`;
const getRefreshToken = () => `${getCurrentApiBaseUrl()}/auth/refresh-token?deviceDataModelId=d36a4373-fbdc-44a3-8c96-4bb920041e40`;
const getUserApi = () => `${getCurrentApiBaseUrl()}/user/user`;
const getUserCustomApi = () => `${getCurrentApiBaseUrl()}/user/user-custom`;
const getPracticeApi = () => `${getCurrentApiBaseUrl()}/user/practice-custom`;
const getCustomApi = () => `${getCurrentApiBaseUrl()}/user/custom-field`;
const getPasswordApi = () => `${getCurrentApiBaseUrl()}/user/password`;
const getUpdatePasswordApi = () => `${getCurrentApiBaseUrl()}/user/updatepassword`;
const getUpdateResetPassword = () => `${getCurrentApiBaseUrl()}/user/password/reset`;
const getInviteEmail = () => `${getCurrentApiBaseUrl()}/user/invite/`;
const getRegisterUserApi = () => `${getCurrentApiBaseUrl()}/user/register`;
const getResendCodeApi = () => `${getCurrentApiBaseUrl()}/user/register/send-code`;
const getAcceptTerms = () => `${getCurrentApiBaseUrl()}/user/tenant/termsagreement?acceptedTermsOfUseForTenant=true`;
const getAcceptTermsUser = () => `${getCurrentApiBaseUrl()}/user/termsagreement?acceptedTermsOfUse=true`;
const getActivateUserApi = () => `${getCurrentApiBaseUrl()}/user/activate`;

const usersService = {
  login: (data) => {
    delete data.email;
    return service.post(getLoginApi(), data, "text");
  },
  getUserList: (payload) => {
    let filter = "";
    if (payload && Object.keys(payload).length > 0) {
      filter = Object.keys(payload).reduce(
        (acc, val, index) =>
          Object.keys(payload).length - 1 === index
            ? `${acc}${val}=${payload[val]}`
            : `${acc}${val}=${payload[val]}&`,
        "?"
      );
    }
    return service.get(`${getUserApi()}${filter}`, {});
  },
  getUserDetailsById: (id) => {
    return service.get(`${getUserApi()}/${id}`, {});
  },
  getUserCustomDataById: (id) => {
    return service.get(`${getCustomApi()}/data/${id}`, {});
  },
  createPractice: (payload) => {
    return service.postJson(getPracticeApi(), {
      customData: null,
      practice: payload,
    });
  },
  createUser: (payload) => {
    return service.postJson(getUserApi(), payload);
  },
  updateUser: (payload) => {
    return service.putJson(getUserCustomApi(), payload);
  },
  deleteUser: (payload) => {
    return service.deleteJson(`${getUserApi()}?userId=${payload.userId}`);
  },
  resetPassword: (payload) => {
    return service.postJson(
      `${getPasswordApi()}/send-reset-code?email=${payload.emailAddress}`,
      {}
    );
  },
  updateUserPassword: (payload) => {
    return service.putJson(getUpdatePasswordApi(), payload);
  },
  resetPasswordUpdate: payload => {
    return service.postJson(getUpdateResetPassword(), payload);
  },
  getInviteEmail: payload => {
    return service.get3Version(getInviteEmail() + payload);
  },
  registerUser: payload => {
    return service.postRegisterForm(getRegisterUserApi(), payload);
  }, 
  activateUser: payload => {
    return service.postVersionJson(getActivateUserApi(), payload, 'text', 3);
  },
  resendCode: payload => {
    return service.postMultipart(getResendCodeApi(), payload);
  },
  acceptTerms: payload => {
    return service.putJson(getAcceptTerms(), payload);
  },
  acceptTermsUser: payload => {
    return service.putJson(getAcceptTermsUser(), payload);
  },
  refreshToken: () => {
    return service.refreshToken(getRefreshToken());
  }
};

export default usersService;
